import React from 'react';
import { Button as MUIButton, withStyles } from "@material-ui/core"
const MUIStyledButton = withStyles((theme)=>({
  root: {
    color: `#fff`,
    borderRadius: `50rem`,
    "&:hover":{
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.main
    }
  }
}))(MUIButton)
const Button = ({children,...props}) => <MUIStyledButton {...props}> {children} </MUIStyledButton>

export default Button;